import { hooks } from '@/store.js'
import { Habit } from '@habitus/verdant'

export const TitleInput = ({ habit }: { habit: Habit }) => {
  const client = hooks.useClient()

  const { name } = hooks.useWatch(habit)

  return (
    <input
      type="text"
      placeholder="Untitled habbit"
      className="-mx-1 w-full text-ellipsis px-1 text-xl outline-none"
      value={name}
      onChange={(e) => {
        client
          .batch({ undoable: false })
          .run(() => {
            habit.set('name', e.target.value)
          })
          .commit()
      }}
    />
  )
}
